(() => {
  const VERSION = '1.0.3';

  const rawQuery = (value) => String(value || '').trim();

  const normalizeKey = (value) =>
    rawQuery(value)
      .toLocaleLowerCase('de-CH')
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ');

  const normalizeArticleNumber = (value) =>
    window.F24SearchNormalizer?.normalize(value) || rawQuery(value);

  const queryForShopify = (value) => normalizeArticleNumber(value);

  const repairLegacyExpandedUrl = () => {
    if (!/\/search\/?$/.test(window.location.pathname)) return false;

    const url = new URL(window.location.href);
    const currentQuery = url.searchParams.get('q') || '';
    const visibleQuery = url.searchParams.get('f24q') || '';

    if (!visibleQuery || !/\sOR\s/i.test(currentQuery)) return false;

    url.searchParams.set('q', queryForShopify(visibleQuery));
    url.searchParams.delete('f24q');
    url.searchParams.set('options[unavailable_products]', 'last');
    window.location.replace(url.toString());
    return true;
  };

  const restoreVisibleQuery = () => {
    const url = new URL(window.location.href);
    const visible = url.searchParams.get('f24q') || url.searchParams.get('q') || '';
    if (!visible) return;

    document.querySelectorAll('input[type="search"]').forEach((input) => {
      input.value = visible;
    });
  };

  window.F24SearchExpander = {
    version: VERSION,
    predictiveMode: 'raw_query',
    submitMode: 'raw_query',
    expand: rawQuery,
    normalizeKey,
    queryForShopify
  };

  const init = () => {
    if (repairLegacyExpandedUrl()) return;
    restoreVisibleQuery();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
